import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-menu",
  "use": "icon-close-menu-usage",
  "viewBox": "0 0 14.881 14.881",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"close-menu\" viewBox=\"0 0 14.881 14.881\" id=\"icon-close-menu\"><g data-name=\"Group 866\"><g data-name=\"Group 863\"><g data-name=\"Group 373\"><path d=\"M12.78.57.96 13.245A.78.78 0 1 0 2.1 14.31L13.92 1.634A.78.78 0 0 0 12.779.57Z\" data-name=\"Path 329\" /></g><g data-name=\"Group 762\"><path d=\"m.57 2.1 12.675 11.82a.78.78 0 1 0 1.065-1.141L1.634.959A.78.78 0 0 0 .57 2.101Z\" data-name=\"Path 329\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol